import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import { API_BASE_URL } from '../../../const.js';


export default class ProjectScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentProject: {
                id: null, 
                name: "", 
                description: "",
                donorid: "",
                donor: "",
                organizationid: "",
                organization: "",
                start: "",
                end: ""
            },
            organizationOptions: [],
            donorOptions: []
        };

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.handleChangeDonor = this.handleChangeDonor.bind(this);
        this.handleChangeOrganization = this.handleChangeOrganization.bind(this);
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.project && this.props.args.project.length > 0) {
            BaseApi.get("/project/project", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.project}, withCredentials: true})
            .then(res => { 
                this.setState({currentProject: res.data})
            })    
            .catch()
        }
        BaseApi.get("/project/donors", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            this.setState({donorOptions: res.data.map(({id, name}) => ({value: id, label: name}))})
        })    
        .catch()

        BaseApi.get("/project/organizations", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            this.setState({organizationOptions: res.data.map(({id, shortname}) => ({value: id, label: shortname}))})
        })    
        .catch()
    }


    save(event) {
        BaseApi.post('/project/project', this.state.currentProject, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentProject = this.state.currentProject
            currentProject.id = res.data.id
            this.setState({currentProject: currentProject})
            this.props.args.project = res.data.id
        })
        .catch(error=>console.log(error))
    
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentProject = this.state.currentProject
        currentProject.name = event.target.value
        this.setState({currentProject: currentProject})
    }

    handleChangeDescription(event) {
        var currentProject = this.state.currentProject
        currentProject.description = event.target.value
        this.setState({currentProject: currentProject})
    }

    handleChangeDonor(selectedOption) {
        var currentProject = this.state.currentProject
        currentProject.donorid = selectedOption.value
        currentProject.donor= selectedOption.label
        this.setState({currentProject: currentProject})
    }

    handleChangeOrganization(selectedOption) {
        var currentProject = this.state.currentProject
        currentProject.organizationid = selectedOption.value
        currentProject.organization = selectedOption.label
        this.setState({currentProject: currentProject})
    }

    handleChangeStart(event) {
        var currentProject = this.state.currentProject
        currentProject.start = event.target.value
        this.setState({currentProject: currentProject})
    }

    handleChangeEnd(event) {
        var currentProject = this.state.currentProject
        currentProject.end = event.target.value
        this.setState({currentProject: currentProject})
    }

    getSummaryReport() {
        const params = {
            'date_from': this.state.currentProject.start, 
            'date_to': this.state.currentProject.end,
            'projectid': this.state.currentProject.id}
        
        BaseApi.post('/project/report/summary', params, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
            .then(res => { 
                const uuid = res.data['uuid']
                this.setState({reportId: uuid, reportSuccess: true})
                window.open(`${API_BASE_URL}project/report/summary/${uuid}`, "blank")
            })
            .catch(error=>console.log(error))
    }

    getCalendarReport() {
        const params = {'projectid': this.state.currentProject.id}
        
        BaseApi.post('/project/report/calendar', params, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
            .then(res => { 
                const uuid = res.data['uuid']
                this.setState({reportId: uuid, reportSuccess: true})
                window.open(`${API_BASE_URL}project/report/calendar/${uuid}`, "blank")
            })
            .catch(error=>console.log(error))

    }

    getDetailReport() {
        const params = {'projectid': this.state.currentProject.id}
        
        BaseApi.post('/project/report/detail', params, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
            .then(res => { 
                const uuid = res.data['uuid']
                console.log("detail reportpost")
                console.log(uuid)
                this.setState({reportId: uuid, reportSuccess: true})
                window.open(`${API_BASE_URL}project/report/detail/${uuid}`, "blank")
            })
            .catch(error=>console.log(error))

    }

    openEvents() {
        this.props.navigate("events", 
        {caller: "project", callargs: this.props.args, projectid: this.state.currentProject.id})

    }

    /*

    openProducts() {
        this.props.navigate("products", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProgramContracts() {
        this.props.navigate("contract-programs", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id, caption: "Контракты", program: this.state.currentProgram})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "program", callargs: this.props.args, refrecid: this.state.currentProgram.id})    
    }

    */

    openProjectPrograms() {
        this.props.navigate("projectprograms", 
        {caller: "project", callargs: this.props.args, project: this.state.currentProject.id})

    }

    render() {
        const projectExists = !!this.state.currentProject.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Проект"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {projectExists ? "Редактирование проекта" : "Новый проект"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name"> Наименование:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentProject.name} onChange={this.handleChangeName} />
                                        <label for="description">Описание:</label>
                                        <input type="text" class="form-control w-100" id="description"  value={this.state.currentProject.description} onChange={this.handleChangeDescription} />
                                        
                                        <div className="mb-3">
                                            <label htmlFor="donor" className="form-label">Источник финансирования</label>
                                            <Select
                                                options={this.state.donorOptions}
                                                id="donor"
                                                onChange={this.handleChangeDonor}
                                                placeholder={this.state.currentProject.donor || "Выберите иточник финансирования"}
                                            />
                                        </div>   

                                        <div className="mb-3">
                                            <label htmlFor="organization" className="form-label">Организация</label>
                                            <Select
                                                options={this.state.organizationOptions}
                                                id="organization"
                                                onChange={this.handleChangeOrganization}
                                                placeholder={this.state.currentProject.organization || "Выберите организацию"}
                                            />
                                        </div>    

                                        <div className="row">
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="start" className="form-label">Начало</label>
                                                <input
                                                type="date"
                                                className="form-control"
                                                id="start"
                                                value={this.state.currentProject.start || ""}
                                                onChange={this.handleChangeStart}
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label htmlFor="end" className="form-label">Завершение</label>
                                                <input
                                                type="date"
                                                className="form-control"
                                                id="end"
                                                value={this.state.currentProject.end || ""}
                                                onChange={this.handleChangeEnd}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>

                                {projectExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openProjectPrograms()}}>
                                                Программы
                                        </button>    
                                        
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>      
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.getSummaryReport()}}>
                                                Сводный отчет
                                        </button>                             
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.getCalendarReport()}}>
                                                Календарь
                                        </button> 
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.getDetailReport()}}>
                                                Детальный отчет
                                        </button>  
                                        {/*<button 
                                             className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openRefs()}}>
                                                Ссылки
                                        </button> 
                                        */}  
                            
                                    </div>
                                )}
                                {!projectExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}

                               
                            </div>
                        </div>
                         <div className="card shadow-sm">
                            <div className="card-body">
                                <span>
                                    За период реализации проекта было проведено {this.state.currentProject.e_count} занятий в {this.state.currentProject.r_count} регионах РФ. В занятиях приняли участие {this.state.currentProject.b_count} человек
                                </span>    
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/project.js